import {
	USER_SET_EMAIL,
	AUTH_UPDATED,
	USER_BUY,
	USER_FETCH,
	USER_SIGN_OUT,
	USER_FETCHING,
	USER_LANGUAGE,
	USER_LANGUAGE_SWITCH
} from "../actions";

const initialState = {
	isLoading: true,
	email: null,
	auth: null,
	surveyPassed: false,
	uid: null,
	locale: "ru"
};

export default function user(state = initialState, action) {
	const { type, payload } = action;
	
	switch (type) {
		case USER_LANGUAGE_SWITCH: {
			return { ...state, locale: payload };
		}
		case USER_LANGUAGE: {
			return { ...state, locale: payload };
		}
		case USER_BUY: {
			const { email } = payload;
			return { ...state, email: email };
		}
		case USER_SET_EMAIL: {
			const { email } = payload;
			return { ...state, email: email };
		}
		case USER_FETCHING: {
			return { ...state, isLoading: payload };
		}
		case USER_FETCH: {
			let { email, surveyPassed = null, uid = null } = payload;
			return { ...state, email, uid, surveyPassed };
		}
		case USER_SIGN_OUT: {
			return { ...state, auth: null, uid: null, email: null, surveyPassed: null };
		}
		case AUTH_UPDATED: {
			const { auth } = payload;
			return { ...state, auth: auth };
		}
		default:
			return state;
	}
}

export const auth = state => state.user.auth;



// WEBPACK FOOTER //
// ./src/reducers/user.js